<div class="responseContainer" *ngIf="!isLoading">
    <div class="responseContainerBody" >
        <div *ngIf="!isMultipleSelection">
            <ul class="buttonList"> 
                <li *ngFor="let responseOption of responseOptions; let i = index " class="responseOptionLi">
                <button mat-button [ngClass]="{'responseOptions': responseOptions!.length! > 1, 'responseOption': responseOptions!.length! <= 1,  'is-mobile-view': isMobileView}" (click)="responseSelected(responseOption.id)">
                    {{responseOption.responseText}}
                </button> 
                </li>
            </ul>
        </div>
        <div *ngIf="isMultipleSelection" class="multipleSelectionDiv">
            <mat-button-toggle-group #group="matButtonToggleGroup" multiple="true" (change)="selectionChanged(group)" class="multipleSelectionContainer">
                <ul class="buttonListMultiple"> 
                    <li *ngFor="let responseOption of responseOptions; let i = index " class="responseOptionLi" >
                        <mat-button-toggle class="responseOptionInGroup" [value]="responseOption.id">
                            {{responseOption.responseText}}
                        </mat-button-toggle> 
                    </li>
                </ul>   
            
            </mat-button-toggle-group>
            <div class="sendButtonContainer" *ngIf="showSendButton">
            <button mat-button class="sendButton" (click)="sendResponse()">
                    {{ 'discoveryProcess.send'| translate }}
                </button> 
            </div>
        </div>
        
    </div>
    <div class="spacingPhotoAndText"></div>
<!-- 
    <div class="responseMemeberIcon">
        <span class="initials">{{chatParticipantInitials}}</span>
    </div> -->
</div>